(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/create-slide-left.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/create-slide-left.js');
"use strict";


const createSlideLeftAsync = (slideComposerAsync, createToCenterTween, createToLeftTween, createSetRightTween) => async slidesList => {
  await slideComposerAsync(slidesList, createToCenterTween, createToLeftTween, createSetRightTween);
};
setGlobal('svs.components.onboarding.slides.animations.createSlideLeftAsync', createSlideLeftAsync);

 })(window);